import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject, takeUntil, take } from 'rxjs';
import { AppState } from 'src/app/shareModule/states/app.state';
import { loadDiscount, selectDiscountData } from 'src/app/shareModule/states/nearby';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { StoryKachiingComponent } from '../story-kachiing/story-kachiing.component';
import { EditBookingContentComponent } from '../edit-booking-content/edit-booking-content.component';
import { Location } from '@angular/common';
import { SharedService } from '../../shareModule/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-customer-connection',
  templateUrl: './customer-connection.component.html',
  styleUrls: ['./customer-connection.component.scss'],
})
export class CustomerConnectionComponent implements OnInit, OnDestroy, OnChanges {
  @Input() filter: string = '';
  @Input() isAdmin: boolean = false;
  @Input() isBookingNow: boolean = false;
  @Input() selectedMapCategory: any = null;
  @Input() currentSelectedTypes: any[] = [];
  @Output() openShowBookingsModal = new EventEmitter<void>();
  @Output() openWhatsAppModal = new EventEmitter<void>();
  public title: string = 'Why Choose Kachiing?';
  public description: string = 'Faster, Better Choices made with decreasing friction of choosing Services using Recommendations from the Community.';
  public icon: string = '';

  private destroy$ = new Subject<void>();
  private modalRef: NgbModalRef;
  public imageUrl: string = environment.ImageUrl;
  public contentList: any[] = [];

  isIconImage(): boolean {
    return this.icon && this.icon.includes('public/');
  }

  getIconImageUrl(): string {
    if (this.isIconImage()) {
      return this.imageUrl + this.icon;
    }
    return '';
  }

  constructor(
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private location: Location,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    // Load discount data when filter is available
    if (this.filter) {
      this.store.dispatch(loadDiscount({ filter: this.filter }));
    }

    // Subscribe to discount data from store
    this.store
      .pipe(
        select(selectDiscountData),
        takeUntil(this.destroy$)
      )
      .subscribe((discountData) => {
        if (discountData) {
          this.title = discountData.connectionTitle || 'Why Choose Kachiing?';
          this.icon = discountData.connectionIcon || '';
          this.description =
            discountData.connectionDescription ||
            'Faster, Better Choices made with decreasing friction of choosing Services using Recommendations from the Community.';
          this.contentList = discountData.contentLists || [];
          this.cdr.detectChanges();
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Reload discount data when filter changes
    if (changes['filter'] && this.filter && !changes['filter'].firstChange) {
      this.store.dispatch(loadDiscount({ filter: this.filter }));
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onButtonClick(): void {
    this.openStore();
  }

  openStore(): void {
    if (this.contentList.length < 1) {
      return;
    }
    // Update URL to include story=1 parameter
    this._updateUrlWithQueryParam('story', '1');

    const modalRef = this.modalService.open(StoryKachiingComponent, {
      size: 'md',
      centered: true,
      backdrop: true,
      keyboard: true,
      windowClass: 'story_modal',
    });

    // Pass filter and category data to the modal component
    const componentInstance = modalRef.componentInstance as StoryKachiingComponent;
    componentInstance.filter = this.filter;
    componentInstance.isBookingNow = this.isBookingNow;
    componentInstance.selectedMapCategory = this.selectedMapCategory;
    componentInstance.currentSelectedTypes = this.currentSelectedTypes;
    componentInstance.openShowBookingsModal.subscribe(() => {
      this.openShowBookingsModal.emit();
    });
    componentInstance.openWhatsApp.subscribe(() => {
      this.openWhatsAppModal.emit();
    });

    // Remove query param when modal closes
    modalRef.hidden.subscribe(() => {
      this._updateUrlWithQueryParam('story', null);
    });
  }

  private _updateUrlWithQueryParam(key: string, value: string | null): void {
    if (!this.sharedService.isBrowser()) {
      return;
    }

    const url = new URL(window.location.href);

    if (value === null) {
      // Remove the query parameter
      url.searchParams.delete(key);
    } else {
      // Add or update the query parameter
      url.searchParams.set(key, value);
    }

    // Build the new URL preserving existing query params
    const newQueryString = url.searchParams.toString();
    const basePath = window.location.pathname
    const newUrl = newQueryString ? basePath + "?" + newQueryString : basePath;
    this.location.replaceState(newUrl);
  }

  onEditClick(event: Event): void {
    this.openEditCustomerConnectionModal(event);
  }

  openEditCustomerConnectionModal(event: Event): void {
    event.stopPropagation();

    this.modalRef = this.modalService.open(EditBookingContentComponent, {
      size: 'md',
      backdrop: 'static',
    });

    // Get current discount data from store
    this.store.pipe(select(selectDiscountData), take(1)).subscribe((discountData) => {
      const componentInstance = this.modalRef
        .componentInstance as EditBookingContentComponent;
      componentInstance.title = discountData?.connectionTitle || 'Why Choose Kachiing?';
      componentInstance.description = discountData?.connectionDescription || 'Faster, Better Choices made with decreasing friction of choosing Services using Recommendations from the Community.';
      componentInstance.icon = discountData?.connectionIcon || '';
      componentInstance.color = discountData?.connectionColor || 'primary';
      componentInstance.connectionText = discountData?.connectionText || '';
      componentInstance.contentLists = discountData?.contentLists || discountData?.contentList || [];
      componentInstance.contentButtonMobileValue = discountData?.contentButtonMobile || false;
      componentInstance.buttonMobileTextValue = discountData?.buttonMobileText || '';
      componentInstance.showTagsValue = discountData?.showTags !== undefined ? discountData.showTags : true;
      componentInstance.filter = this.filter;
      componentInstance.type = 'connection';
      componentInstance.bookNowText = discountData?.bookNowText || '';

      componentInstance.contentSaved.subscribe((content) => {
        // Data will be updated via store subscription
        this.cdr.detectChanges();
      });
    });
  }
}

